export default {
    CURRENT_EDITION_DUPLICATE: 1,
    CURRENT_EDITION_SIMILAR: 2
};
